import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIRoutes } from '../global-misc/api-routes';
import { MeModel as MeModel } from '../global-data-models/me.model';
import { firstValueFrom, BehaviorSubject, Observable } from 'rxjs';
import { getAuth } from 'firebase/auth';
import { GuardHelper } from '../global-guards/guard.helper';
import { CreateOrgModel, OrgModel, UpdateOrgModel } from '../global-data-models/org.model';

@Injectable({ providedIn: 'root' })
export class OrgService {
  constructor(private http: HttpClient) {}

  async createOrg(org: CreateOrgModel): Promise<any> {
    const apiRoute = APIRoutes.ORGS_ROUTE;
    return await firstValueFrom(this.http.post<any>(apiRoute, org));
  }

  async updateOrg(orgId: string, org: UpdateOrgModel): Promise<any> {
    if (orgId === undefined) {
      throw new Error('Org ID is required for update');
    }
    const apiRoute = APIRoutes.SINGLE_ORG_ROUTE.replace(':orgId', orgId);
    return await firstValueFrom(this.http.patch<UpdateOrgModel>(apiRoute, org));
  }

  async getOrg(orgId: string): Promise<OrgModel> {
    const apiRoute = APIRoutes.SINGLE_ORG_ROUTE.replace(':orgId', orgId);
    return await firstValueFrom(this.http.get<OrgModel>(apiRoute));
  }
}
